import Loader from "components/loader"
import { UseQueryResult } from "@tanstack/react-query"
import { IPresence } from "../../types"
import { useTranslation } from "react-i18next"

const RecommendedIntervention: React.FC<{
  member: UseQueryResult<IPresence["member"]>
}> = ({ member }) => {
  const { t } = useTranslation()
  return (
    <>
      {member.isLoading ? (
        <Loader />
      ) : (
        <div
          className="noStylesReset"
          dangerouslySetInnerHTML={{
            __html:
              [
                ...(member.data?.displayed_recommended_intervention?.filter(
                  (item) => item !== t("labels.other", { count: 1 })
                ) || []),
                member.data?.displayed_recommended_intervention?.includes(
                  t("labels.other", { count: 1 })
                ) && member.data?.recommended_intervention_other
                  ? member.data?.recommended_intervention_other
                  : null,
              ]
                .filter((item) => item !== null)
                .join(", ") ?? "",
          }}
        />
      )}
    </>
  )
}

export default RecommendedIntervention
